'use client';

import { useState } from 'react';
import * as Dialog from './design-dialog';
import { AppleLogo, ArrowUpRight, GooglePlayLogo, X } from '@phosphor-icons/react';

// The same store destinations as the main site's mobile-app-banner.tsx.
const stores = [
  {
    name: 'App Store',
    platform: 'Для iPhone',
    url: 'https://apps.apple.com/ru/app/азиаточка-доставка-еды/id6761508832',
    Icon: AppleLogo,
  },
  {
    name: 'Google Play',
    platform: 'Для Android',
    url: 'https://play.google.com/store/apps/details?id=com.steepdesign.aziaapp',
    Icon: GooglePlayLogo,
  },
];

function AppArtwork({ size = 'compact' }: { size?: 'compact' | 'dialog' }) {
  return (
    <span className={`app-artwork app-artwork--${size}`} aria-hidden="true">
      <img
        className="app-artwork-scene"
        src="/storefront/campaign-v6-app-download.webp"
        width={1280}
        height={800}
        alt=""
        loading="lazy"
        decoding="async"
      />
      <span className="app-artwork-copy">
        <strong>
          Роллы
          <br />
          под рукой.
        </strong>
      </span>
    </span>
  );
}

export function AppDownloadBanner() {
  const [open, setOpen] = useState(false);

  return (
    <Dialog.Root open={open} onOpenChange={setOpen}>
      <Dialog.Trigger asChild>
        <button
          className="app-download-banner"
          aria-label="Роллы под рукой. Скачать приложение Азиаточка для iPhone или Android"
        >
          <AppArtwork />
          <span className="app-download-cta">
            Скачать приложение <ArrowUpRight size={17} aria-hidden="true" />
          </span>
        </button>
      </Dialog.Trigger>
      <Dialog.Portal>
        <Dialog.Overlay className="dialog-overlay" />
        <Dialog.Content className="app-download-dialog">
          <Dialog.Close className="dialog-close" aria-label="Закрыть">
            <X size={23} />
          </Dialog.Close>
          <div className="app-download-dialog-art">
            <AppArtwork size="dialog" />
          </div>
          <div className="app-download-dialog-copy">
            <Dialog.Title>Твои роллы — в приложении</Dialog.Title>
            <Dialog.Description className="app-download-description">
              Выбирай любимые роллы, копи коины и заказывай с телефона.
            </Dialog.Description>
            <div className="app-store-links">
              {stores.map(({ name, platform, url, Icon }) => (
                <a
                  key={name}
                  href={url}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={`Скачать Азиаточку в ${name}`}
                >
                  <Icon size={29} weight="fill" />
                  <span>
                    <small>{platform}</small>
                    <strong>{name}</strong>
                  </span>
                  <ArrowUpRight size={19} />
                </a>
              ))}
            </div>
          </div>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  );
}
